import { Link } from 'react-router-dom'

export function NGvsCaseid({useCaseid, slug, noWorkq, children, caseid, person_number, className}) {
    const href = useCaseid
        ? `${noWorkq ? '/cases' : `/work-queues/${slug}`}/${caseid}`
        : `${noWorkq ? '/cases' : `/work-queues/${slug}`}/${person_number}`

    return <Link to={href} className={className}>{children}</Link>
}